module.exports = __webpack_public_path__ + "img/bread-account-center.12b35966.png";